class GridColumnController {
    constructor($transclude) {
        this.transclude = $transclude;
    }

    $onInit() {
        this.grid.addColumn(this, this.columnIndex);
    }
}

GridColumnController.$inject = ['$transclude'];

const gridColumnDirective = {
    restrict: 'E',
    scope: true,
    controller: GridColumnController,
    controllerAs: 'gridColumnCtrl',
    bindToController: {
        columnClass: '<?',
        sortKey: '<?',
        columnIndex: '<?'
    },
    transclude: {
        'header': '?ctxColumnHeader',
        'editor': '?ctxColumnEditor',
        'footer': '?ctxColumnFooter',
    },
    require: {
        grid: '^ctxGrid'
    }
};

module.exports = function () {
    return gridColumnDirective;
};



// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGridColumn.directive.js